import * as React from 'react';
import { get } from '../../components/request';
import { autobind } from '../../modules/@wmeimob/decorator/src';
import * as styles from './index.module.less';
import { appId } from '../../config';

interface IPageProps {
}
interface IPageState {
}
@autobind
export default class Page extends React.PureComponent<IPageProps, IPageState> {

    state = {
    }

    render() {
        return <div className={styles.page}>
            {/* <MMButton onClick={this.onClick}>确定订阅</MMButton> */}
            自动订阅中...
        </div >;
    }

    onClick() {
        wx.miniProgram.navigateTo({ url: '/pages/home/index' });
    }

    async componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        const code = searchParams.get('code');
        const tel = searchParams.get('tel') || localStorage.getItem('tel');
        localStorage.setItem('tel', tel as string);

        if (code) {
            console.log(code, 'code');

            // localStorage.setItem('code', code as string);
            await get('/wechat/user/getOpenId', {
                code,
                tel
            })
            wx.miniProgram.reLaunch({ url: '/pages/home/index?success=true' });
        } else {
            console.log(appId, 'appId');

            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId
                + '&redirect_uri=' + window.location.origin + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
        }
    }

}

